(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-home-materials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bd-material-carousel')) {
 class BDMaterialCarousel extends HTMLElement {
  connectedCallback() {
   this.rail = this.querySelector('.bd-home-materials__grid');
   this.controls = this.querySelector('.bd-home-materials__controls');
   this.previous = this.querySelector('[data-direction="-1"]');
   this.next = this.querySelector('[data-direction="1"]');
   if (!this.rail || !this.controls) return;
   this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   this.update = () => {
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    this.controls.hidden = max < 2;
    this.previous.disabled = this.rail.scrollLeft < 2;
    this.next.disabled = this.rail.scrollLeft >= max - 2;
   };
   this.move = direction => {
    const card = this.rail.querySelector('.bd-home-material');
    if (!card) return;
    const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
    this.rail.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
   };
   this.controls.addEventListener('click', event => {
    const button = event.target.closest('button[data-direction]');
    if (button) this.move(Number(button.dataset.direction));
   }, options);
   this.rail.addEventListener('keydown', event => {
    if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    this.move(event.key === 'ArrowRight' ? 1 : -1);
   }, options);
   this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
   this.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.bd-home-material');
    if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
   }, options);
   this.observer = new ResizeObserver(this.update);
   this.observer.observe(this.rail);
   this.update();
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
  }
 }
 customElements.define('bd-material-carousel', BDMaterialCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-pro-value"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bd-pro-value')) {
 customElements.define('bd-pro-value', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.addEventListener('input', () => this.update());
   this.update();
  }
  update() {
   const read = key => {
    const input = this.querySelector('[data-input="' + key + '"]');
    const n = Number(input.value);
    return Number.isFinite(n) ? Math.max(0, Math.min(Number(input.max), n)) : 0;
   };
   const spend = read('spend'), order = read('order');
   const rate = spend < 20000 || order <= 0 ? 0 : order <= 5000 ? .01 : order <= 15000 ? .03 : .05;
   const cash = spend * rate;
   const extra = read('returns') + read('storage') + read('hours') * read('hourly');
   const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',maximumFractionDigits:0}).format(n);
   const set = (key, value) => this.querySelector('[data-' + key + ']').textContent = value;
   set('spend',money(spend)); set('cash',money(cash)); set('extra',money(extra)); set('total',money(cash+extra)); set('rate',Math.round(rate*100)+'%');
   set('tier',spend >= 50000 ? this.dataset.vip : spend >= 20000 ? this.dataset.preferred : this.dataset.select);
   this.querySelector('[data-input="spend"]').setAttribute('aria-valuetext',money(spend));
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
